export default {
      id: "Group_98-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#Group_98",
      toString: function () {
        return this.url;
      }
    }